import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';
import {DialogProvider} from 'react-mui-dialog'
import { BrowserRouter } from 'react-router-dom';
import ScrollToTopWrapper from './ScrollToTop';


ReactDOM.render(
  <React.StrictMode>
    <DialogProvider>
    <BrowserRouter>
    <ScrollToTopWrapper>
    <App/>
    </ScrollToTopWrapper>
    </BrowserRouter>
    </DialogProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
